<template>
  <div class="bank-columns__container">
    <app-modal-row style="gap: 52px;">
      <app-modal-col cols="3">
        <v-list dense class="py-0" style="padding:0; margin:0;">
          <v-subheader class="table-subheader">
            <span class="title">Orden</span>
            <span>&nbsp;*(Columnas Optativas)</span>
          </v-subheader>

          <draggable v-model="excelColumnList" animation="200" @change="onDragChange" @end="onDragEnd">
            <transition-group>
              <v-list-item
                v-for="(excelColumn, columnIndex) in excelColumnList"
                :key="excelColumn.value"
                :style="{
                  padding:'0', margin:'0',
                  border:'1px solid #E4DAFF',
                  borderTopWidth: columnIndex===0?'1px':'0',
                  borderRadius: columnIndex===excelColumnList.length-1 ? '0 0 8px 8px' : '0',
                  overflow:'hidden', display:'flex', alignItems:'stretch',
                  transition:'background 120ms ease, box-shadow 120ms ease', cursor:'grab'
                }"
              >
                <div :style="{
                  width:'44px',minWidth:'44px',display:'flex',alignItems:'center',justifyContent:'center',
                  fontWeight:'700',color:'var(--v-primary-base)',background:'#EDE4FF',letterSpacing:'0.5px',userSelect:'none',
                  borderTopLeftRadius: columnIndex===0?'8px':'0',
                  borderBottomLeftRadius: columnIndex===excelColumnList.length-1?'8px':'0'
                }">
                  {{ String.fromCharCode(65 + columnIndex) }}
                </div>

                <div 
                  :style="{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    padding: '12px 22px',
                    background: '#FAF8FF',
                    color: '#4F4F4F',
                    fontFamily: 'Roboto',
                    fontSize: '12px',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: '16px',
                    borderLeft: '1px solid #EDE4FF',
                    borderTopRightRadius: columnIndex === 0 ? '8px' : '0',
                    borderBottomRightRadius: columnIndex === excelColumnList.length - 1 ? '8px' : '0'
                  }"
                >
                  {{ excelColumn.text }}
                </div>

                <div v-if="isColumnRemovable(excelColumn)" style="display:flex;align-items:center;padding-right:6px;">
                  <v-btn icon small style="color:var(--v-primary-base);" @click.stop="removeExcelColumn(excelColumn)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-list-item>
            </transition-group>
          </draggable>
        </v-list>
      </app-modal-col>

      <app-modal-col cols="7" style="display:flex;flex-direction:column;gap:20px;padding:0;max-width: 100%;">

        <div style="display:flex;flex-direction:column;margin:0;">
          <v-subheader class="input-subheader">Líneas excluidas</v-subheader>
          <div class="excluded-lines__input">
            <span class="excluded-lines__label">Selecciona la cantidad.</span>
            <div class="excluded-lines__input-box">
              <input
                id="quantity"
                v-model.number="totalHeaderLinesToIgnore"
                type="number"
                min="0"
              />
            </div>
          </div>
          <span class="excluded-lines__hint">
            (Por defecto es 1, poner 0 si se cargan datos sin cabecera)
          </span>
        </div>

        <div class="actions__row">
          <v-btn small outlined @click="addIgnoreExcelColumn" class="action__btn">
            <v-icon>mdi-plus-circle-outline</v-icon>
            Columna a ignorar
          </v-btn>

          <v-btn small outlined @click="addConcatenateExcelColumn" class="action__btn">
            <!-- <v-icon>mdi-link-variant-plus</v-icon> -->
            <div 
              style="
                width: 24px;
                height: 24px;
                flex-shrink: 0;
                background: #FFF;
              "
              >
              <AppIcon :src="require('../../../frontend/public/bank/arrow_and_edge.svg')" :size="29" style="width: 24px;
                height: 24px;
                flex-shrink: 0;
                aspect-ratio: 1/1;
              " />
            </div>
            Concatenar columna al concepto
          </v-btn>
        </div>
      </app-modal-col>
    </app-modal-row>
  </div>
</template>

<script>
import draggable from "vuedraggable"
import AppModalCol from "@/components/layout/AppModalCol.vue"
import AppModalRow from "@/components/layout/AppModalRow.vue"
import { BankColumns } from "@/modules/bank/domain/BankColumns"

export default {
  name: "BankColumnsConfiguratorTab",
  components: { draggable, AppModalCol, AppModalRow },
  props: {
    excel_format: { type: Object, required: true },
    currentBankAccount: { type: Object, default: null }
  },
  data() {
    return {
      bankColumnsLogic: null,
      excelColumnList: [],
      totalHeaderLinesToIgnore: 1,
    }
  },
  created() {
    this.refreshViewFromFormat(this.excel_format)
  },
  watch: {
    excel_format: {
      handler(newFormat) {
        this.refreshViewFromFormat(newFormat)
      },
      deep: true,
    },
    totalHeaderLinesToIgnore(newValue) {
      if (!this.bankColumnsLogic) return
      this.bankColumnsLogic.setHeaderLinesToIgnore(
        Number.isFinite(newValue) ? newValue : 0
      )
      this.emitUpdatedFormat() 
    }
  },
  methods: {
    refreshViewFromFormat(format) {
      this.bankColumnsLogic = BankColumns.createFromFormat(format)
      const view = this.bankColumnsLogic.toView()
      this.excelColumnList = view.columns
      this.totalHeaderLinesToIgnore = view.numberOfHeaderLinesToIgnore
    },

    emitUpdatedFormat() {
      const order = this.excelColumnList.map(c => c.value)
      this.bankColumnsLogic.setOrder(order)
      const errors = this.bankColumnsLogic && this.bankColumnsLogic.validate
      ? this.bankColumnsLogic.validate()
      : []

      if (errors.length) {
        this.$emit("error", errors)
        return
      }
      const updatedFormat = this.bankColumnsLogic.toFormat()
      updatedFormat.is_default = false;
      this.$emit("update:excel_format", updatedFormat)
      this.$emit("confirm", updatedFormat)
    },

    addIgnoreExcelColumn() {
      this.bankColumnsLogic.addIgnoreColumn()
      this.refreshViewFromFormat(this.bankColumnsLogic.toFormat())
      this.emitUpdatedFormat()
    },

    addConcatenateExcelColumn() {
      this.bankColumnsLogic.addConcatenateColumn()
      this.refreshViewFromFormat(this.bankColumnsLogic.toFormat())
      this.emitUpdatedFormat()
    },

    isColumnRemovable(column) {
      return this.bankColumnsLogic.canRemoveColumn(column)
    },

    removeExcelColumn(column) {
      this.bankColumnsLogic.removeColumn(column)
      this.refreshViewFromFormat(this.bankColumnsLogic.toFormat())
      this.emitUpdatedFormat()
    },

    onDragChange() {
      const newOrder = this.excelColumnList.map(c => c.value)
      this.bankColumnsLogic.setOrder(newOrder)
      this.refreshViewFromFormat(this.bankColumnsLogic.toFormat())
      this.emitUpdatedFormat()
    },
    onDragEnd() {},
  },
}
</script>

<style scoped>
.input-subheader {
  align-self: stretch;
  color: #565656;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  padding: 0;
}

.table-subheader {
  width: 207px;
  color: #888;
  font-family: Roboto;
  font-size: 11px;
  font-weight: 500;
}

.table-subheader .title {
  color: #565656;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.excluded-lines__input,
.text-field__account-moviment {
  display: flex;
  align-items: center;
  border: 1px solid #D9D9D9;
  border-radius: 4px;
  padding: 6px 4px 3px 12px;
  background: #fff;
  gap: 6px;
  height: 42px;
}

.excluded-lines__label,
.text-lines__label {
  flex: 1;
  font-family: Roboto;
  font-size: 12px;
  color: #4F4F4F;
}

.excluded-lines__input-box {
  display: flex;
  background: #F3F3F3;
  border-radius: 4px;
  padding: 6px 4px 3px 12px;
}

.excluded-lines__input-box input {
  border: none;
  background: transparent;
  width: 60px;
  font-family: Roboto;
  font-size: 12px;
  color: #565656;
  text-align: right;
}

.excluded-lines__hint {
  font-size: 12px;
  color: #777;
  display: flex;
  justify-content: flex-end;
}

.actions__row {
  border-radius: 10px;
  background: #F3F3F3;
  display: flex;
  gap: 52px;

  .v-btn__content {
    gap: 10px;
  }
}

.action__btn {
  display: flex;
  align-items: center;
  font-size: 13px;
  text-transform: none;
  font-weight: 500;
  padding: 0 !important;
  border: none !important;
  gap: 10px;
}
</style>
